import React from 'react'
import PropTypes from 'prop-types'



// import Plyr from "plyr-react";
// import "plyr-react/dist/plyr.css";


// Old OLD PLYR
// import Plyr from 'react-plyr'
import 'plyr/dist/plyr.css'
import loadable from '@loadable/component'
const Plyr = loadable(() => import('react-plyr'))
// END OLD PLYR

class Video extends React.Component {
  static propTypes = {
    videos: PropTypes.array,
    // video: {
    //   id: PropTypes.number,
    //   movie: PropTypes.string,
    //   source: PropTypes.string,
    //   audio:PropTypes.string,
    //   subtitles: PropTypes.string,
    //   url: PropTypes.string,
    //   type: PropTypes.string,
    // }
  }

  state = {

  }

  render() {
    if(!this.props.videos) return ''
    if(this.props.videos.length === 0) return ''

    let video = []
    const videos = this.props.videos.map(i => {
      if (i.source === 'archive') {
        video.push(<Archive url={i.url} />)
      } else if(i.source === 'youtube') {
        let id = i.url.split('?v=')[1];
        if (id && id.includes('&')) {
          id = id.split('&')[0]
        }
        video.unshift(<Youtube id={id} />)
      } else if(i.source === 'dailymotion') {
        video.unshift(<DailyMotion url={i.url} />)
      } else if(i.source === 'vimeo') {
        let id = i.url.split('vimeo.com/')[1]
        video.unshift(<Vimeo id={id} />)
      }
    })
    return video[0]
  }
}

export default Video

const VideoSizeContainer = ({children}) => (
  <div className="tab-content" id="nav-tabContent">
    <div className="tab-pane fade show active" id="nav-archive" role="tabpanel" aria-labelledby="nav-archive-tab">
      {children}
    </div>
  </div> 
)

const Youtube = ({id}) => (
    <Plyr
      key={id}
      type="youtube" // or "vimeo"
      videoId={id}
      // onLoadedData={i => i.play()}
      onReady={i => { i.play() }}
      // onSeeked={i => console.log(i)}
      // onTimeUpdate={i => console.log(i)}
      // onEnd={i => console.log("Video seen till the end !")}
      autoplay="true"
    />
)

// const Youtube = ({id}) => (
//   <div className="">
//     <Plyr source={{
//       type: "video",
//       sources: [
//         {
//           src: id,
//           provider: "youtube"
//         }
//       ]
//     }} 
//     options={{
//       autoplay:true,
//       ratio:'16:9'
//     }} 
//     />
//   </div>
// )
const Archive = ({url}) => (
  <div className="tab-content" id="nav-tabContent">
    <div className="tab-pane fade show active" id="nav-archive" role="tabpanel" aria-labelledby="nav-archive-tab">
     <iframe src={`${url}&autoplay=1`} webkitallowfullscreen="true" mozallowfullscreen="true" allowFullScreen></iframe>
    </div>
  </div> 
)
// const Vimeo = ({id}) => (
//   <div>
//     <Plyr source={{
//       type: "video",
//       sources: [
//         {
//           src: id,
//           provider: "vimeo"
//         }
//       ]
//     }} 
//     options={{
//       autoplay:true, 
//      }} />
//   </div>
// )
const Vimeo = ({id}) => (
  <Plyr
    type="vimeo"
    videoId={id}
    onReady={i => { i.play() }}
    autoplay="true"
  />
)

const DailyMotion = ({url}) => (
  <div className="tab-content" id="nav-tabContent">
    <div className="tab-pane fade show active" id="nav-archive" role="tabpanel" aria-labelledby="nav-archive-tab">
      <iframe src={`${url}?autoplay=1&queue-enable=false`} allowFullScreen allow="autoplay; fullscreen" frameBorder="0"></iframe>
    </div>
  </div> 
)